import Vue from 'vue'
import VueRouter from 'vue-router'
import Configure from '@/views/Configure'
import Informations from '@/views/Informations'
import Done from '@/views/Done'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/configure'
  },
  {
    path: '/configure',
    name: 'configure',
    component: Configure,
  },
  {
    path: '/informations',
    name: 'informations',
    component: Informations
  },
  {
    path: '/done',
    name: 'done',
    component: Done
  },
  {
    path: '*',
    redirect: '/'
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    window.top.document.getElementById('ledconfigurator').scrollIntoView()
  }
})

export default router
